import { useState, useEffect } from "react";
import { degrees, PDFDocument, rgb, StandardFonts } from "pdf-lib";
import PDFTEMPLATE from "../assets/flyers/flyer3.pdf";
import OTHLLogo from "../assets/images/OTHL-logo.png";
import fontkit from "@pdf-lib/fontkit";
import RobotoFontCondensed from "../assets/fonts/Roboto-BoldCondensed.ttf";
import MinionFont from "../assets/fonts/MinionPro-Regular.otf";
import ArlialnFont from "../assets/fonts/ARIALN.ttf";

async function addFormattedTextandImages(
  userData,
  previewOrDownload,
  setLoading,
  enableCobranding,
  cobrandHeadshot
) {
  let url = userData.flyerChoice.filePath;
  let brandColorObj = userData.brand.rgbHeader;
  let headerColor = rgb(brandColorObj[0], brandColorObj[1], brandColorObj[2]);
  // const licensingSplit = userData.brand.Licensing.slice(0, 30); // first line
  // const licensingSplit2 = userData.brand.Licensing.slice(30); // second line

  let brandCtaColorObj = userData.brand.rgbCta;
  let ctaColor = rgb(
    brandCtaColorObj[0],
    brandCtaColorObj[1],
    brandCtaColorObj[2]
  );

  if (window.location.hostname === "localhost") {
    url = PDFTEMPLATE;
  }

  let branchLicense = userData.branch.Licensing;

  let licensingLineOne = userData.brand.licensingLineOne;
  let licensingLineTwo = userData.brand.licensingLineTwo;
  let licensingLineThree = userData.brand.licensingLineThree;
  let licensingLineFour = userData.brand.licensingLineFour;

  if (userData.flyerChoice.Spanish == true) {
    branchLicense = userData.branch.SpanishLicensing;
    licensingLineOne = userData.brand.SpanishlicensingLineOne;
    licensingLineTwo = userData.brand.SpanishlicensingLineTwo;
    licensingLineThree = userData.brand.SpanishlicensingLineThree;
    licensingLineFour = userData.brand.SpanishlicensingLineFour;
  }

  let nmmlNumberHeight = 149;
  let officeNumber = 137;
  let mobileNumberHeight = 125;
  let faxNumberHeight = 113;
  let emailHeight = 101;
  let mloWebsiteHeight = 89;

  if (userData.settings.user.mobileNumber === false) {
    faxNumberHeight = faxNumberHeight + 12;
    emailHeight = emailHeight + 12;
    mloWebsiteHeight = mloWebsiteHeight + 12;
  }

  if (userData.settings.user.faxNumber === false) {
    emailHeight = emailHeight + 12;
    mloWebsiteHeight = mloWebsiteHeight + 12;
  }

  if (
    userData.settings.user.headshot === true &&
    (userData.settings.user.mobileNumber === false ||
      userData.settings.user.faxNumber === false)
  ) {
    emailHeight = emailHeight - 12;
    mloWebsiteHeight = mloWebsiteHeight - 12;
  }

  if (
    userData.settings.user.headshot === true &&
    userData.settings.user.mobileNumber === false &&
    userData.settings.user.faxNumber === false
  ) {
    emailHeight = emailHeight - 12;
    mloWebsiteHeight = mloWebsiteHeight - 12;
  }

  let person = userData.userData;
  const existingPdfBytes = await fetch(url, {
    method: "GET",
    headers: {
      "Content-Type": "application/pdf",
    },
  }).then((res) => res.arrayBuffer());

  const fontBytesforRoboto = await fetch(RobotoFontCondensed).then((res) =>
    res.arrayBuffer()
  );

  const fontBytesforMinion = await fetch(MinionFont).then((res) =>
    res.arrayBuffer()
  );
  const fontBytesforArlian = await fetch(ArlialnFont).then((res) =>
    res.arrayBuffer()
  );

  const pdfDoc = await PDFDocument.load(existingPdfBytes);
  pdfDoc.registerFontkit(fontkit);
  const robotoFontCondensed = await pdfDoc.embedFont(fontBytesforRoboto);
  // const minionFont = await pdfDoc.embedFont(fontBytesforMinion);
  const arlianFont = await pdfDoc.embedFont(fontBytesforArlian);
  const minionFont = await pdfDoc.embedFont(StandardFonts.TimesRoman);
  const helveticaFont = await pdfDoc.embedFont(StandardFonts.Helvetica);
  const helveticaBoldFont = await pdfDoc.embedFont(StandardFonts.HelveticaBold);

  const pages = pdfDoc.getPages();
  const firstPage = pages[0];
  const { width, height } = firstPage.getSize();
  // console.log(width, height);
  // console.log(userData.brand.headerColor);

  if (userData.brand.hasHeader) {
    firstPage.drawRectangle({
      x: 0,
      y: 734,
      width: 612,
      height: 90,
      color: headerColor,
    });
  }

  if (userData.flyerChoice.Spanish === true) {
    let ctaText = "LLAME A SU EQUIPO DE FINANCIAMENTO DE VIVIENDAS HOY!";
    let textX = 35;
    let boxX = 35;
    let fontSize = 11;

    if (
      userData.flyerChoice.ctaLineOne !== "" &&
      userData.flyerChoice.ctaLineOne !== undefined &&
      userData.flyerChoice.ctaLineOne !== null
    ) {
      ctaText = `${userData.flyerChoice.ctaLineOne}`;
    }

    // Measure text width
    const textWidth = robotoFontCondensed.widthOfTextAtSize(ctaText, fontSize);
    const boxWidth = textWidth + 10 * 2; // Add padding to both sides

    // Draw the rectangle dynamically based on text width
    firstPage.drawRectangle({
      x: boxX,
      y: 191,
      width: boxWidth,
      height: 19,
      color: ctaColor,
    });

    // Draw the text
    firstPage.drawText(ctaText, {
      x: textX + 10, // Add padding to the left side
      y: 196,
      font: robotoFontCondensed,
      size: fontSize,
      color: rgb(1, 1, 1),
    });
  } else {
    let ctaText = "CALL YOUR HOME FINANCING TEAM TODAY!";
    let boxX = 32;
    let fontSize = 12;

    if (
      userData.flyerChoice.ctaLineOne !== "" ||
      userData.flyerChoice.ctaLineTwo !== ""
    ) {
      ctaText = `${userData.flyerChoice.ctaLineOne} ${userData.flyerChoice.ctaLineTwo}`;
    }

    console.log(userData.flyerChoice.ctaLineOne);
    // Measure text width
    const textWidth = robotoFontCondensed.widthOfTextAtSize(ctaText, fontSize);
    const boxWidth = textWidth + 10 * 2; // Add padding to both sides

    // Draw the rectangle dynamically based on text width
    firstPage.drawRectangle({
      x: boxX,
      y: 191,
      width: boxWidth,
      height: 19,
      color: ctaColor,
    });

    // Calculate centered position for text
    const textX = boxX + (boxWidth - textWidth) / 2;

    // Draw the text
    firstPage.drawText(ctaText, {
      x: textX,
      y: 196,
      font: robotoFontCondensed,
      size: fontSize,
      color: rgb(1, 1, 1),
    });
  }

  firstPage.drawText(
    `${person.FirstName.toUpperCase()} ${person.LastName.toUpperCase()}`,
    {
      x: width - 497,
      y: 174,
      size: 14.5,
      font: robotoFontCondensed,
      color: rgb(0.196, 0.196, 0.196),
      weight: "bold",
    }
  );

  const textWidth = minionFont.widthOfTextAtSize(`${person.Title}`, 10);
  const trimmedTitle = person.Title.split(" ");
  let titleHeight = 163;
  let textHeight = 0;

  let length = 0;
  let line = "";
  let lines = [];
  for (let i = 0; i < trimmedTitle.length; i++) {
    let testLine = line + trimmedTitle[i] + " ";
    let testWidth = minionFont.widthOfTextAtSize(testLine, 10);
    if (testWidth > 100) {
      lines.push(line);
      line = trimmedTitle[i] + " ";
    } else {
      line = testLine;
    }
  }
  lines.push(line);

  for (let i = 0; i < lines.length; i++) {
    firstPage.drawText(`${lines[i]}`, {
      x: width - 497,
      y: titleHeight,
      size: 10,
      font: minionFont,
      color: rgb(0, 0, 0),
    });
    titleHeight -= 11;
  }

  textHeight = titleHeight - 1;

  if (person.LoanForce__NMLS_Number__c !== "") {
    firstPage.drawText(`NMLS #${person.LoanForce__NMLS_Number__c}`, {
      x: width - 497,
      y: textHeight,
      size: 10,
      font: minionFont,
      color: rgb(0, 0, 0),
    });
    textHeight -= 12;
  }

  firstPage.drawText(`O: ${person.Phone}`, {
    x: width - 497,
    y: textHeight,
    size: 10,
    font: minionFont,
    color: rgb(0, 0, 0),
  });
  textHeight -= 12;

  if (userData.settings.user.mobileNumber) {
    firstPage.drawText(`M: ${person.Mobile_Phone_Formatted__c}`, {
      x: width - 497,
      y: textHeight,
      size: 10,
      font: minionFont,
      color: rgb(0, 0, 0),
    });
    textHeight -= 12;
  }
  if (userData.settings.user.faxNumber) {
    firstPage.drawText(`F:  ${person.Fax}`, {
      x: width - 497,
      y: textHeight,
      size: 10,
      font: minionFont,
      color: rgb(0, 0, 0),
    });
    textHeight -= 12;
  }
  firstPage.drawText(`E: ${person.Email}`, {
    x: width - 497,
    y: textHeight,
    size: 10,
    font: minionFont,
    color: rgb(0, 0, 0),
  });
  textHeight -= 12;

  if (userData.settings.user.customMloWebsite === true) {
    firstPage.drawText(`${userData.settings.user.customMloWebsiteUrl}`, {
      x: width - 497,
      y: textHeight,
      size: 10,
      font: minionFont,
      color: rgb(0, 0, 0),
    });
    textHeight -= 12;
  }

  let subDomainUrl = "contact/";

  if (
    userData.settings.user.mloWebsite &&
    !userData.settings.user.customMloWebsite
  ) {
    firstPage.drawText(
      `${userData.brand.WebsiteUrl}${subDomainUrl}${person.Account}`,
      {
        x: width - 497,
        y: textHeight,
        size: 10,
        font: minionFont,
        color: rgb(0, 0, 0),
      }
    );
    textHeight -= 12;
  }
  // console.log(userData.userData.mloHeadshotFinal);
  if (userData.userData.mloHeadshotFinal === "") {
    // console.log("no headshot");
  } else {
    const headshotImage = await fetch(person.mloHeadshotFinal).then((res) =>
      res.arrayBuffer()
    );
    const headshot = await pdfDoc.embedPng(headshotImage);
    if (userData.settings.user.headshot) {
      firstPage.drawImage(headshot, {
        x: width - 580,
        y: 105,
        width: 77,
        height: 80,
      });
    }
  }
  // download the headshotImage

  // const pngUrl = userData.brand.whiteLogoUrl;
  const pngUrl = userData.brand.whiteLogoUrl;
  const pngImageBytes = await fetch(pngUrl).then((res) => res.arrayBuffer());
  const pngImage = await pdfDoc.embedPng(pngImageBytes);

  let pngDims = pngImage.scale(0.6);

  if (userData.brand.BrandName === "Tabor Mortgage") {
    pngDims = pngImage.scale(0.7);
  }

  firstPage.drawImage(pngImage, {
    x: firstPage.getWidth() / 2 - pngDims.width / 2,
    y: firstPage.getHeight() - pngDims.height / 2 - 30,
    height: pngDims.height,
    width: pngDims.width,
  });

  // LICENSING INFORMATION
  //
  //
  //
  //
  //
  //
  //
  //
  //LICENSING INFORMATION

  let textFontSize = 8;

  if (userData.flyerChoice.Spanish == true) {
    textFontSize = 7;
  }

  firstPage.drawText(`NMLS #${userData.branch.NMLS}`, {
    x: width - 535,
    y: 56,
    size: textFontSize,
    font: arlianFont,
    color: rgb(0.196, 0.196, 0.196),
  });
  firstPage.drawText(`${userData.branch.Address}`, {
    x: width - 420,
    y: 56,
    size: textFontSize,
    font: arlianFont,
    color: rgb(0.196, 0.196, 0.196),
  });

  firstPage.drawText(`${branchLicense}`, {
    x: width - 535,
    y: 46,
    size: textFontSize,
    font: arlianFont,
    color: rgb(0.196, 0.196, 0.196),
  });

  // userData.brand.licensing break up into an array of words

  firstPage.drawText(`${licensingLineOne}`, {
    x: width - 535,
    y: 36,
    size: textFontSize,
    font: arlianFont,
    color: rgb(0.196, 0.196, 0.196),
  });
  firstPage.drawText(`${licensingLineTwo}`, {
    x: width - 535,
    y: 26,
    size: textFontSize,
    font: arlianFont,
    color: rgb(0.196, 0.196, 0.196),
  });
  firstPage.drawText(`${licensingLineThree}`, {
    x: width - 535,
    y: 16,
    size: textFontSize,
    font: arlianFont,
    color: rgb(0.196, 0.196, 0.196),
  });

  let reverseFLyer = userData.flyerChoice.name.includes("Reverse Mortgage");

  if (
    userData.brand.reverseLicensing !== "" &&
    userData.brand.reverseLicensing !== null &&
    userData.brand.reverseLicensing !== undefined &&
    reverseFLyer &&
    userData.flyerChoice.b2b
  ) {
    // replace "BRAND_URL" in userData.brand.reverseLicensing with userData.brand.WebsiteUrl
    userData.brand.reverseLicensing = userData.brand.reverseLicensing.replace(
      /BRAND_URL/g,
      userData.brand.WebsiteUrl
    );

    firstPage.drawText(
      `${licensingLineFour} ${userData.brand.reverseLicensing} ${userData.flyerChoice.b2bLanguage}`,
      {
        x: width - 535,
        y: 6,
        size: textFontSize,
        font: arlianFont,
        color: rgb(0.196, 0.196, 0.196),
      }
    );
  } else if (
    userData.brand.reverseLicensing !== "" &&
    userData.brand.reverseLicensing !== null &&
    userData.brand.reverseLicensing !== undefined &&
    reverseFLyer
  ) {
    // replace "BRAND_URL" in userData.brand.reverseLicensing with userData.brand.WebsiteUrl
    userData.brand.reverseLicensing = userData.brand.reverseLicensing.replace(
      /BRAND_URL/g,
      userData.brand.WebsiteUrl
    );

    firstPage.drawText(
      `${licensingLineFour} ${userData.brand.reverseLicensing}`,
      {
        x: width - 535,
        y: 6,
        size: textFontSize,
        font: arlianFont,
        color: rgb(0.196, 0.196, 0.196),
      }
    );
  } else if (userData.flyerChoice.b2b) {
    firstPage.drawText(
      `${licensingLineFour} ${userData.flyerChoice.b2bLanguage}`,
      {
        x: width - 535,
        y: 6,
        size: textFontSize,
        font: arlianFont,
        color: rgb(0.196, 0.196, 0.196),
      }
    );
  } else {
    firstPage.drawText(`${licensingLineFour}`, {
      x: width - 535,
      y: 6,
      size: textFontSize,
      font: arlianFont,
      color: rgb(0.196, 0.196, 0.196),
    });
  }

  /// CO BRANDING SECTION

  //
  //
  //
  //
  /// CO BRANDING SECTION

  let cobrandCompanyNameHeight = 150;
  let cobrandPhoneNumberHeight;
  let cobrandFaxNumberHeight = 140;
  let cobrandEmailHeight = 128;
  let cobrandWebsite = 116;

  if (enableCobranding && userData.settings.coBrand.firstName !== "") {
    firstPage.drawText(
      `${userData.settings.coBrand.firstName.toUpperCase()} ${userData.settings.coBrand.lastName.toUpperCase()}`,
      {
        x: width - 233,
        y: 174,
        size: 14.5,
        font: robotoFontCondensed,
        color: rgb(0.196, 0.196, 0.196),
        weight: "bold",
      }
    );
  }

  const textWidthCompany = minionFont.widthOfTextAtSize(
    `${userData.settings.coBrand.companyName}`,
    10
  );
  const trimmedCompany = userData.settings.coBrand.companyName.split(" ");
  console.log(trimmedCompany);

  if (enableCobranding && userData.settings.coBrand.companyName !== "") {
    let length = 0;
    let line = "";
    let lines = [];
    for (let i = 0; i < trimmedCompany.length; i++) {
      let testLine = line + trimmedCompany[i] + " ";
      let testWidth = minionFont.widthOfTextAtSize(testLine, 10);
      if (testWidth > 200) {
        lines.push(line);
        line = trimmedCompany[i] + " ";
      } else {
        line = testLine;
      }
    }
    lines.push(line);

    for (let i = 0; i < lines.length; i++) {
      firstPage.drawText(`${lines[i]}`, {
        x: width - 233,
        y: cobrandCompanyNameHeight,
        size: 10,
        font: minionFont,
        color: rgb(0.196, 0.196, 0.196),
      });
      cobrandCompanyNameHeight -= 11;
    }
  }

  if (
    (enableCobranding && userData.settings.coBrand.companyName !== "") ||
    userData.settings.coBrand.companyName !== null
  ) {
    cobrandPhoneNumberHeight = cobrandCompanyNameHeight - 1;
    cobrandFaxNumberHeight = cobrandCompanyNameHeight - 12;
    cobrandEmailHeight = cobrandCompanyNameHeight - 24;
    cobrandWebsite = cobrandCompanyNameHeight - 36;
  }

  if (enableCobranding && userData.settings.coBrand.phoneNumber === "") {
    cobrandEmailHeight = cobrandEmailHeight - 12;
    cobrandFaxNumberHeight = cobrandFaxNumberHeight + 12;
    cobrandWebsite = cobrandWebsite + 12;
  }

  if (enableCobranding && userData.settings.coBrand.faxNumber === "") {
    cobrandWebsite = cobrandWebsite + 12;
    cobrandEmailHeight = cobrandEmailHeight + 12;
  }
  if (enableCobranding && userData.settings.coBrand.email === "") {
    // cobrandFaxNumberHeight = cobrandFaxNumberHeight - 12;
    cobrandWebsite = cobrandWebsite + 12;
  }

  // if (enableCobranding && cobrandHeadshot) {
  //   cobrandEmailHeight = 116;
  //   cobrandWebsite = 104;
  // }
  if (enableCobranding && userData.settings.coBrand.title !== "") {
    firstPage.drawText(`${userData.settings.coBrand.title}`, {
      x: width - 233,
      y: 162,
      size: 10,
      font: minionFont,
      color: rgb(0, 0, 0),
    });
  }

  if (enableCobranding && userData.settings.coBrand.phoneNumber !== "") {
    firstPage.drawText(`O: ${userData.settings.coBrand.phoneNumber}`, {
      x: width - 233,
      y: cobrandPhoneNumberHeight,
      size: 10,
      font: minionFont,
      color: rgb(0, 0, 0),
    });
  }
  if (enableCobranding && userData.settings.coBrand.faxNumber !== "") {
    firstPage.drawText(`M: ${userData.settings.coBrand.faxNumber}`, {
      x: width - 233,
      y: cobrandFaxNumberHeight,
      size: 10,
      font: minionFont,
      color: rgb(0, 0, 0),
    });
  }

  if (enableCobranding && userData.settings.coBrand.email !== "") {
    firstPage.drawText(`E: ${userData.settings.coBrand.email}`, {
      x: width - 233,
      y: cobrandEmailHeight,
      size: 10,
      font: minionFont,
      color: rgb(0, 0, 0),
    });
  }

  if (enableCobranding && userData.settings.coBrand.website !== "") {
    firstPage.drawText(`${userData.settings.coBrand.website}`, {
      x: width - 233,
      y: cobrandWebsite,
      size: 10,
      font: minionFont,
      color: rgb(0, 0, 0),
    });
  }

  if (enableCobranding && cobrandHeadshot) {
    const cobrandHeadshotUrl = cobrandHeadshot;
    // remove jpg from cobrandHeadshotUrl
    const cobrandHeadshotUrlNoJpg = cobrandHeadshotUrl.slice(0, -4);

    // console.log(cobrandHeadshotUrlNoJpg);
    const cobrandedFinal = cobrandHeadshotUrlNoJpg + ".png";
    // console.log(cobrandedFinal);
    const pngImageBytes3 = await fetch(cobrandedFinal).then((res) =>
      res.arrayBuffer()
    );
    const cobrandHeadshotimage = await pdfDoc.embedPng(pngImageBytes3);

    firstPage.drawImage(cobrandHeadshotimage, {
      x: width - 318,
      y: 105,
      width: 77,
      height: 80,
    });
  }

  const pdfBytes = await pdfDoc.save();
  const blob = new Blob([pdfBytes], { type: "application/pdf" });
  const url2 = URL.createObjectURL(blob);
  console.log(blob, "here");

  if (previewOrDownload === "preview") {
    window.open(url2, "_blank");
  }
  if (previewOrDownload === "download") {
    //make sure file is pdf
    const fileName = `${userData.flyerChoice.name}.pdf`;
    const a = document.createElement("a");
    a.href = url2;
    a.download = fileName;
    a.click();
  }
  setLoading(false);
  return pdfBytes;
}

export default addFormattedTextandImages;
